import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import emailVerifiedImage from '../assets/email_verified.svg';

const EmailVerifyPage = () => {
  const [status, setStatus] = useState('loading');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Temporary verification function
  const verifyEmail = async (token) => {
    await new Promise(resolve => setTimeout(resolve, 3000));
    return Math.random() > 0.5;
  };

  useEffect(() => {
    const verify = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setStatus('failed');
        return;
      }

      const success = await verifyEmail(token);
      setStatus(success ? 'success' : 'failed');
    };

    verify();
  }, [searchParams]);

  if (status === 'loading') {
    return (
      <div className="container py-8">
        <div className="max-w-[406px] mx-auto flex items-center justify-center">
          <p className="text-lg">Verifying your email...</p>
        </div>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div className="container py-8">
        <div className="max-w-[406px] mx-auto flex items-center justify-center">
          <p className="text-lg">404 - Verification failed</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-8">
      <div className="max-w-[406px] mx-auto flex flex-col items-center">
        <div className="w-[280px] h-[183px] relative">
          <img 
            src={emailVerifiedImage} 
            alt="Email verified" 
            className="w-full h-full"
          />
        </div>
        <div className="w-full flex flex-col items-center gap-6 mt-9">
          <div className="flex flex-col items-center gap-2">
            <div className="text-center text-[#111111] text-lg font-bold">
              Email Verification Complete
            </div>
            <div className="text-center text-[#111111] text-lg">
              {searchParams.get('email') || 'test@gmail.com'}
            </div>
          </div>
          <div className="text-center text-[#aaaaaa] text-sm tracking-tight">
            Your email has been verified successfully!
          </div>
          <button
            onClick={() => navigate('/')}
            className="px-7 py-2 bg-white rounded-[28px] border border-[#dddddd] hover:bg-gray-50"
          >
            <span className="text-center text-[#111111] text-lg font-bold">
              Back to Home
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerifyPage; 